/* eslint-disable no-secrets/no-secrets */
import { defineMessages } from 'react-intl';

export default defineMessages({
    riskInfoAccordionDetails: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.Is Vessel used for Recreational Private Pleasure use only?',
        defaultMessage: 'Is Vessel used for Recreational Private Pleasure use only?',
    },
	isVesuseforRecPriPonlFie: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.Is this used for guided fishing charter?',
        defaultMessage: 'Is this used for guided fishing charter?',
    },
	isthiuseforguifiscchaFie: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.Is this Boat Leased?(Please Note: Leased boats do not qualify)',
        defaultMessage: 'Is this Boat Leased?(Please Note: Leased boats do not qualify)',
    },
	isthiboalivaboasasresFie: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.Is this boat lived aboard as a seasonal or primary residence?',
        defaultMessage: 'Is this boat lived aboard as a seasonal or primary residence?',
    },
	hasanyinsevecandecforFie: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.Has any insurer ever cancelled, declined or refused to renew or issue insurance of the type applied for?',
        defaultMessage: 'Has any insurer ever cancelled, declined or refused to renew or issue insurance of the type applied for?',
    },
	doyouoranylivundyoothFie: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.Do you, or anyone living under your roof or having access to the insured premises or property, ever been prosecuted or convicted in proceedings of any kind, whether they be criminal, penal, civil or other?',
        defaultMessage: 'Do you, or anyone living under your roof or having access to the insured premises or property, ever been prosecuted or convicted in proceedings of any kind, whether they be criminal, penal, civil or other?',
    },
	ifYesPleNamTheEncTec7: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.If yes, please name the encryption technologies used',
        defaultMessage: 'If yes, please name the encryption technologies used',
    },
	isTheAVirProProIn8: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.Is there a virus protection program in place?',
        defaultMessage: 'Is there a virus protection program in place?',
    },
	areTheFirInPla9: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.Are there firewalls in place?',
        defaultMessage: 'Are there firewalls in place?',
    },
	title: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.Risk Information',
        defaultMessage: 'Risk Information',
    },
    ifnoexpFie: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.If no, explain',
        defaultMessage: 'If no, explain'
    },
    ifYesexpwhehowlonawhyFie: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.If Yes, explain (when, how long and why)',
        defaultMessage: 'If Yes, explain (when, how long and why)'
    },
    ifyespleprodetFie: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.If yes, please provide details',
        defaultMessage: 'If yes, please provide details'
    },
    underwritingTitle: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.Underwriting',
        defaultMessage: 'Underwriting'
    },
    newFieldsPopulated: {
        id: 'quoteandbind.PRMMarLinedirectives.templates.RiskInformation.New input field may appear based on their response',
        defaultMessage: 'New input field may appear based on their response'
    }   
});